import React from "react";
import {EmployeeTimeEntry} from "@/data/entities/employee";
import DeleteTimeEntry from "@widgets/employees/editor/timeEntries/edit/DeleteTimeEntry";
import {SetStateFn} from "@/utils/SetStateUtils";
import EditTimeEntry from "@widgets/employees/editor/timeEntries/edit/EditTimeEntry";

type Props = {
    entry: EmployeeTimeEntry,
    setLastUpdated: SetStateFn<Date>,
};

const EditEntryOptions = ({entry, setLastUpdated}: Props) => {
    return (
        <div className={"flex flex-row flex-nowrap items-center justify-end gap-6"}>
            <DeleteTimeEntry
                entry={entry}
                setLastUpdated={setLastUpdated}
            />

            <EditTimeEntry
                entry={entry}
                setLastUpdated={setLastUpdated}
            />
        </div>
    );
};

export default EditEntryOptions;